import { generateId } from '@va/util/helpers';

export function mapFromFormValues(values, preserveQuestionId) {
  return {
    ...values,
    questions: values.questions.map((question) => {
      const { isNew, ...questionFields } = question;
      // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
      const { id, ...questionWithoutId } = questionFields;

      return {
        ...(preserveQuestionId && !isNew ? questionFields : questionWithoutId),
        choices: question.choices?.map((choice) => choice.value),
        hasDescription: !!question.description,
      };
    }),
  };
}

export function mapToFormValues(values) {
  return {
    ...values,
    questions: values.questions.map((question) => {
      // eslint-disable-next-line no-unused-vars
      return {
        ...question,
        createdAt: undefined,
        choices: question.choices?.map((choice) => ({
          value: choice,
          id: generateId(),
        })),
        hasDescription: !!question.description,
      };
    }),
  };
}
